import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { NoDataMessage } from "@/components/atoms";
import { Sort } from "@/components/atoms/Sorting/useSort";
import { TabPanel } from "@/components/molecules";
import { SeeAllButton } from "@/components/pages/Dashboard/shared";
import { InvoiceSortProperty } from "@/shared/domain/invoices";

import InvoiceCard from "../../components/InvoiceCard/InvoiceCard";
import InvoiceTable from "../../components/InvoiceTable/InvoiceTable";
import { MAX_PRIVATE_ITEMS, MAX_PRO_ITEMS, TabIndex } from "../constants";

type InvoiceTabPanelProps = {
    tableMode: boolean;
    invoices: MyBrokerApi.Invoice[];
    orderBy: Sort<InvoiceSortProperty>;
    panelValue: TabIndex;
    panelIndex: TabIndex;
    dataTestId: string;
    handleSort: (property: InvoiceSortProperty) => void;
    handleSeeMore: () => void;
};

const InvoiceTabPanel: FC<InvoiceTabPanelProps> = ({
    invoices,
    orderBy,
    tableMode,
    handleSort,
    handleSeeMore,
    dataTestId,
    panelIndex,
    panelValue,
}) => {
    const { t } = useTranslation();

    const maxItems = tableMode ? MAX_PRO_ITEMS : MAX_PRIVATE_ITEMS;
    const displayShowMoreButton = (items: MyBrokerApi.Invoice[]) => {
        return items.length > maxItems;
    };

    const items = invoices.first(maxItems);

    return (
        <TabPanel key={panelIndex} data-testid={dataTestId} value={panelValue} index={panelIndex}>
            {invoices.length === 0 && <NoDataMessage>{t("Invoices.Empty")}</NoDataMessage>}
            {invoices.length > 0 && tableMode && (
                <InvoiceTable invoices={items} orderBy={orderBy} handleSort={handleSort} />
            )}
            {invoices.length > 0 &&
                !tableMode &&
                items.map((item) => <InvoiceCard key={`invoice-${item.id}`} invoice={item} />)}

            {displayShowMoreButton(invoices) && (
                <SeeAllButton onClick={handleSeeMore} dataTestId="invoices_tabs-button-more" />
            )}
        </TabPanel>
    );
};

export default InvoiceTabPanel;
